import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoryCourseOfflineList from './category_course_offline_list';
import CategoryCourseOfflineDetail from './category_course_offline_detail';

class CategoryCourseOffline extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CategoryCourseOfflineList/>;
    }else{
      if(params.id===undefined){
        view = <CategoryCourseOfflineDetail/>;
      }else{
        view = <CategoryCourseOfflineDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

CategoryCourseOffline.contextTypes = {
  router: PropTypes.object
};

export default CategoryCourseOffline;
